import {graphql, useFragment} from 'react-relay'
import {Token} from '@primer/react'
import type {HeaderBlockedBySummary$key} from './__generated__/HeaderBlockedBySummary.graphql'
import {NoEntryIcon} from '@primer/octicons-react'
import styles from './HeaderBlockedBySummary.module.css'

export type HeaderBlockedBySummaryProps = {
  blockedBySecondaryKey?: HeaderBlockedBySummary$key
  size?: 'xlarge' | 'small'
}

export const HeaderBlockedBySummary = ({blockedBySecondaryKey, size = 'xlarge'}: HeaderBlockedBySummaryProps) => {
  const node = useFragment(
    graphql`
      fragment HeaderBlockedBySummary on Issue {
        issueDependenciesSummary {
          blockedBy
        }
      }
    `,
    blockedBySecondaryKey,
  )

  const {blockedBy} = node?.issueDependenciesSummary ?? {}

  if (!node || !blockedBy) return <></>
  return <HeaderBlockedBySummaryInternal blockedBy={blockedBy} size={size} />
}

export type HeaderBlockedBySummaryInternalProps = {
  blockedBy: number
  size: 'xlarge' | 'small'
}

export function HeaderBlockedBySummaryInternal({blockedBy, size}: HeaderBlockedBySummaryInternalProps) {
  const visualLabel = `Blocked by ${blockedBy}`
  const label = `Blocked by ${blockedBy} issue${blockedBy === 1 ? '' : 's'}`

  if (size === 'small') {
    return (
      <div className={styles.smallSummary}>
        <NoEntryIcon className="fgColor-danger" />
        <span aria-hidden="true" className={styles.visualLabel}>
          {blockedBy}
        </span>
        <span className="sr-only">{label}</span>
      </div>
    )
  }

  return (
    <Token
      text={
        <>
          <span aria-hidden="true" className={styles.visualLabel}>
            {visualLabel}
          </span>
          <span className="sr-only">{label}</span>
        </>
      }
      leadingVisual={() => <NoEntryIcon className="fgColor-danger" />}
      className={styles.token}
      size="xlarge"
    />
  )
}

try{ HeaderBlockedBySummary.displayName ||= 'HeaderBlockedBySummary' } catch {}
try{ HeaderBlockedBySummaryInternal.displayName ||= 'HeaderBlockedBySummaryInternal' } catch {}